import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=5ee2f860"
import script from "./authLayout.vue?vue&type=script&lang=js"
export * from "./authLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports